import React, { useEffect, useState } from 'react';
import useTooth from '../../Hooks/Tooth/useTooth';
import { ToothRestoration } from '../../../../graphql/graphql';
import DENTModalOverviewRestorationCrownButtons from './DENTModalOverviewRestorationCrownButtons';

const DENTModalOverviewRestorationCrown = () => {
	const { restoration } = useTooth();

	const [values, setValues] = useState<ToothRestoration | undefined>(
		restoration.data,
	);

	useEffect(() => {
		if (values) {
			restoration.setRestoration(values);
		}
	}, [values]);

	return (
		<DENTModalOverviewRestorationCrownButtons
			values={values}
			setValues={setValues}
		/>
	);
};

export default DENTModalOverviewRestorationCrown;
